import axios from 'axios';
import api from './api.services';
import { fetchApiDataFailure } from '../_actions/common.actions';
import {fetchBookDetailsSuccess} from "../_actions/bookdetails.actions";
import {fetchCollectionNotes,saveCollectionNotes} from "../_actions/collection.notes.action";
import {showMessage} from "../_actions/message.actions";


export const saveBookDetails = (collectionId,params) => (dispatch, getState)  => {
    axios.post(api.save_book_details.replace('{collection-id}', collectionId), {bookdetails: getState().bookdetailsreducer , title: getState().activeCollection.title})
        .then(response => {
            dispatch(fetchBookDetailsSuccess(response.data));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const getBookDetails =  (collectionId) => dispatch => {
    axios.get(api.get_book_details.replace('{collection-id}',collectionId))
        .then(response => {
            dispatch(fetchBookDetailsSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};

export const getCollectionNotes = (collectionId) => dispatch => {
    axios.get(api.get_notes.replace('{collection-id}',collectionId))
        .then(response => {
            dispatch(fetchCollectionNotes(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};

export const saveNotes = (params) => (dispatch)  => {
    axios.post(api.add_notes, {params})
        .then(response => {
            dispatch(saveCollectionNotes(response.data));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));

        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};



// WEBPACK FOOTER //
// ./src/_thunks/bookdetails.thunk.js